/**
 * Created by mykurisu on 2017/8/21.
 */
const defaults = {
    urlData: null,
    currentListInit: false,
    current: null,
    currentList: null,
    selectedList: null,
    //cardContent
    inviteCard: null,
    lectureInfo: {},
    speakerId: null
};


export default (state=defaults, action) => { //SET_SMALLCLASS_SPEAKER
    switch(action.type){
        case 'SET_SMALLCLASS_SPEAKER':
        return {...state, speakerId: action.payload};
        case 'SET_INVITE_TARGET_ID':
            return {...state, urlData: action.payload};
        case 'SET_INVITE_LECTURE_INFO':
            return {...state, lectureInfo: action.payload};
        case 'LECTURER_INVITE_INIT':
            return {...state, currentListInit: true, current: action.payload};
        case 'LECTURER_INVITE_APPEND':
            return {...state, currentList: action.payload};
        case 'LECTURER_SELECTED_LIST':
            return {...state, selectedList: action.payload};
        case 'LECTURER_INVITE_CARD_INIT':
            return {...state, inviteCard: action.payload};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/lecturerInvite.js